/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { Component } from 'react';
import { object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import WineDialog from './WineDialog';
import { transformCharacters } from '../../../../../helpers/markdown/characterTransformer';

const styles = () => ({
    wineContent: {
        width: '96%',
        margin: '5px 0px 0px 0px',
        '& a': {
            color: 'initial',
        },
    },
    link: {
        fontSize: '16px',
        textDecoration: 'underline',
        margin: '0 .5em 0 0',
        '&:hover': {
            cursor: 'pointer',
        },
    },
});

class WineDisclaimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialog: false,
        };
    }

    openDialog = () => {
        this.setState({ openDialog: true });
    }

    closeDialog = () => {
        this.setState({ openDialog: false });
    }

    renderers = (openDialog) => ({
        text: ({ value }) => {
            const { classes, data } = this.props;
            if (value.includes('Click Here')) {
                return (
                    <div className={classes.promotion}>
                        <span
                            onClick={this.openDialog}
                            onKeyDown={() => { }}
                            role="button"
                            tabIndex={-1}
                            className={classes.link}
                            data-testid="about-Wine-disclaimer-click"
                        >
                            Click Here
                        </span>
                        {transformCharacters(value.replace('Click Here', ''))}
                        {openDialog
                && (
                    <WineDialog
                        oncloseDialog={this.closeDialog}
                        data={data}
                    />
                )}
                    </div>
                );
            }
            return transformCharacters(value);
        },
        linkReference: ({ href, children }) => <a href={href} rel="noreferrer" target="_blank">{children}</a>,
    });

    render() {
        const { classes, data } = this.props;
        const { openDialog } = this.state;
        // const [aboutWineDisclaimer] =  data?.findContent?.content?.entries?.[0]?.spots?.filter((item) => item.content_spot.name === 'About the Wine');
        const aboutWineDisclaimer =  data?.findContent?.content?.entries?.[0]?.spots?.filter((item) => item.content_spot.name === 'About the Wine')[0]; // TODO: array desctructing failed on testing
        return (
            <div className={classes.wineContent}>
                {aboutWineDisclaimer?.content_spot?.name &&  <h4>{aboutWineDisclaimer?.content_spot?.name}</h4>}
                <ReactMarkdown source={aboutWineDisclaimer?.content_spot?.content} renderers={this.renderers(openDialog)} escapeHtml={false} />
            </div>
        );
    }
}
WineDisclaimer.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
};
export default withStyles(styles)(WineDisclaimer);
